import { useState, useEffect } from "react";
import firebase from "firebase/compat/app";
import "firebase/compat/firestore";

/**
 * Load organization document from organizations/{organizationId}.
 * Used to read org-level settings such as unitSystem ("imperial" | "metric").
 */
export function useOrganization(organizationId) {
  const [organization, setOrganization] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!organizationId) {
      setOrganization(null);
      setLoading(false);
      setError(null);
      return;
    }
    setLoading(true);
    setError(null);
    const ref = firebase
      .firestore()
      .collection("organizations")
      .doc(organizationId);
    const unsubscribe = ref.onSnapshot(
      (snapshot) => {
        if (snapshot.exists) {
          setOrganization({ id: snapshot.id, ...snapshot.data() });
        } else {
          setOrganization(null);
        }
        setLoading(false);
      },
      (err) => {
        setError(err);
        setOrganization(null);
        setLoading(false);
      }
    );
    return () => unsubscribe();
  }, [organizationId]);

  const unitSystem = organization?.unitSystem ?? "imperial";
  const weightUnit = unitSystem === "metric" ? "kg" : "lbs";

  return { organization, loading, error, unitSystem, weightUnit };
}
